import { render, staticRenderFns } from "./DepartmentsComponent.vue?vue&type=template&id=16ad846e&"
import script from "./DepartmentsComponent.vue?vue&type=script&lang=js&"
export * from "./DepartmentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports